import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e7735b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "zync-editor" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "flex mx-auto px-12 m-14" }
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = { class: "flex justify-center items-center" }
const _hoisted_7 = {
  class: "w-full max-w-xs flex flex-col py-5 px-8",
  action: ""
}
const _hoisted_8 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<a href=\"https://youtube.com\" target=\"_blank\" data-v-6e7735b4><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"1em\" height=\"1em\" preserveAspectRatio=\"xMidYMid meet\" viewBox=\"0 0 24 24\" data-v-6e7735b4><g fill=\"none\" data-v-6e7735b4><g clip-path=\"url(#svgIDa)\" data-v-6e7735b4><path fill=\"currentColor\" d=\"M23.5 6.507a2.786 2.786 0 0 0-.766-1.27a3.05 3.05 0 0 0-1.338-.742C19.518 4 11.994 4 11.994 4a76.624 76.624 0 0 0-9.39.47a3.16 3.16 0 0 0-1.338.76c-.37.356-.638.795-.778 1.276A29.09 29.09 0 0 0 0 12c-.012 1.841.151 3.68.488 5.494c.137.479.404.916.775 1.269c.371.353.833.608 1.341.743c1.903.494 9.39.494 9.39.494a76.8 76.8 0 0 0 9.402-.47a3.05 3.05 0 0 0 1.338-.742a2.78 2.78 0 0 0 .765-1.27A28.38 28.38 0 0 0 24 12.023a26.579 26.579 0 0 0-.5-5.517ZM9.602 15.424V8.577l6.26 3.424l-6.26 3.423Z\" data-v-6e7735b4></path></g><defs data-v-6e7735b4><clipPath id=\"svgIDa\" data-v-6e7735b4><path fill=\"#fff\" d=\"M0 0h24v24H0z\" data-v-6e7735b4></path></clipPath></defs></g></svg></a>", 1)
const _hoisted_10 = ["value"]
const _hoisted_11 = { for: "characters_total" }
const _hoisted_12 = { class: "characters_total" }
const _hoisted_13 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_18 = ["value"]
const _hoisted_19 = { for: "verse_total" }
const _hoisted_20 = { class: "verse_total" }
const _hoisted_21 = { class: "lyrics-section m-14" }
const _hoisted_22 = ["title"]
const _hoisted_23 = { class: "lyrics" }
const _hoisted_24 = ["id"]
const _hoisted_25 = ["onClick", "disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "m11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"
  })
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  contenteditable: "false",
  class: "text-base text-xs"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "m15 16l-2.414-2.414A2 2 0 0 1 12 12.172V6" })
  ])
], -1))
const _hoisted_30 = ["onPaste"]
const _hoisted_31 = ["onUpdate:modelValue", "max", "onInput"]
const _hoisted_32 = ["id"]
const _hoisted_33 = ["value", "onChange"]
const _hoisted_34 = { class: "med-text text-3xl" }
const _hoisted_35 = ["id"]
const _hoisted_36 = { class: "med-text text-xl focus:border-light-blue-500 focus:ring-1 focus:ring-light-blue-500 focus:outline-none text-sm text-black placeholder-gray-500 border border-gray-200 rounded-md py-2 pl-4 mx-14" }
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "med-text text-xl focus:border-light-blue-500 focus:ring-1 focus:ring-light-blue-500 focus:outline-none text-sm text-black placeholder-gray-500 border border-gray-200 rounded-md py-2 pl-4 mx-14" }
const _hoisted_39 = ["value"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-4 h-4 absolute right-0 top-0 mt-2 mr-3 text-gray-500" }, " EN ", -1))
const _hoisted_41 = { class: "med-text text-xl focus:border-light-blue-500 focus:ring-1 focus:ring-light-blue-500 focus:outline-none text-sm text-black placeholder-gray-500 border border-gray-200 rounded-md py-2 pl-4 mx-14" }
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "mode-controls" }
const _hoisted_44 = ["title"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59c-.125.36-.479 1.013-1.04 1.639c-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545c1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484c.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464c.201-.263.38-.578.488-.901c.11-.33.172-.762.004-1.149c.069-.13.12-.269.159-.403c.077-.27.113-.568.113-.857c0-.288-.036-.585-.113-.856a2.144 2.144 0 0 0-.138-.362a1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272c-.847-.282-1.803-.276-2.516-.211a9.84 9.84 0 0 0-.443.05a9.365 9.365 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111L8.864.046zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164c-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868c-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65c1.095-.3 1.977-.996 2.614-1.708c.635-.71 1.064-1.475 1.238-1.978c.243-.7.407-1.768.482-2.85c.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725a.5.5 0 0 0 .595.644l.003-.001l.014-.003l.058-.014a8.908 8.908 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164c.175.058.45.3.57.65c.107.308.087.67-.266 1.022l-.353.353l.353.354c.043.043.105.141.154.315c.048.167.075.37.075.581c0 .212-.027.414-.075.582c-.05.174-.111.272-.154.315l-.353.353l.353.354c.047.047.109.177.005.488a2.224 2.224 0 0 1-.505.805l-.353.353l.353.354c.006.005.041.05.041.17a.866.866 0 0 1-.121.416c-.165.288-.503.56-1.066.56z"
  })
], -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = ["title"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M15.173 2H4c-1.101 0-2 .9-2 2v12c0 1.1.899 2 2 2h12c1.101 0 2-.9 2-2V5.127L15.173 2zM14 8c0 .549-.45 1-1 1H7c-.55 0-1-.451-1-1V3h8v5zm-1-4h-2v4h2V4z"
  })
], -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = ["title"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 1024 1024"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504L738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512L828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496L285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512L195.2 285.696a64 64 0 0 1 0-90.496z"
  })
], -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = { class: "line-controls" }
const _hoisted_54 = ["disabled", "title"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M17 4.252c0-1-1.116-1.595-1.947-1.038L6.554 8.921a1.25 1.25 0 0 0-.007 2.071l8.5 5.793A1.25 1.25 0 0 0 17 15.752v-11.5ZM3 3.5a.5.5 0 0 1 1 0v13a.5.5 0 0 1-1 0v-13Z"
  })
], -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = ["disabled", "title"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M2 3.002a1 1 0 0 1 1.578-.816l7 4.963a1 1 0 0 1 .007 1.628l-7 5.037A1 1 0 0 1 2 13.003V3.002ZM14 2.5a.5.5 0 1 0-1 0v11a.5.5 0 0 0 1 0v-11Z"
  })
], -1))
const _hoisted_59 = [
  _hoisted_58
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YouTube = _resolveComponent("YouTube")!
  const _component_Timeline = _resolveComponent("Timeline")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_YouTube, {
              id: "player",
              width: "100%",
              height: "100%",
              src: 'https://www.youtube.com/watch?v=' + _ctx.lyrics.videoId,
              onReady: _ctx.onReady,
              onStateChange: _ctx.onPlayerStateChange,
              onError: _ctx.onPlayerError,
              vars: _ctx.playerVars,
              ref: "player"
            }, null, 8, ["src", "onReady", "onStateChange", "onError", "vars"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("form", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, [
                  _hoisted_9,
                  _createTextVNode(" " + _toDisplayString(_ctx.labels_youtube_video_id) + ": ", 1)
                ]),
                _createElementVNode("input", {
                  class: "text-gray-700 shadow border rounded border-gray-300 focus:outline-none focus:shadow-outline py-1 px-3 mb-3",
                  type: "text",
                  placeholder: "Video Id",
                  value: _ctx.lyrics.videoId,
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onVideoUrlUpdate && _ctx.onVideoUrlUpdate(...args)))
                }, null, 40, _hoisted_10),
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.labels_duration) + ": ", 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.videoDuration / 60) + " " + _toDisplayString(_ctx.labels_minutes), 1),
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.labels_song_title) + ": ", 1),
                _createElementVNode("input", {
                  class: "text-gray-700 shadow border rounded border-gray-300 mb-3 py-1 px-3 focus:outline-none focus:shadow-outline",
                  type: "text",
                  placeholder: "",
                  value: _ctx.lyrics.songTitle
                }, null, 8, _hoisted_14),
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.labels_band_name) + ": ", 1),
                _createElementVNode("input", {
                  class: "text-gray-700 shadow border rounded border-gray-300 mb-3 py-1 px-3 focus:outline-none focus:shadow-outline",
                  type: "text",
                  placeholder: "",
                  value: _ctx.lyrics.bandName
                }, null, 8, _hoisted_16),
                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.labels_year) + ": ", 1),
                _createElementVNode("input", {
                  class: "text-gray-700 shadow border rounded border-gray-300 mb-3 py-1 px-3 focus:outline-none focus:shadow-outline",
                  type: "text",
                  placeholder: "",
                  value: _ctx.lyrics.yearPublished
                }, null, 8, _hoisted_18),
                _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.labels_verse_total) + ": ", 1),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.lyrics.verses.length), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            class: "btn btn-icon btn-secondary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startTimer && _ctx.startTimer(...args))),
            title: _ctx.actions_play
          }, _toDisplayString(_ctx.actions_play), 9, _hoisted_22),
          _createElementVNode("ul", _hoisted_23, [
            (_ctx.lyrics)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.lyrics.verses, (lyric, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: lyric.id,
                    id: 'ly-' + i,
                    class: "lyric",
                    contenteditable: "true"
                  }, [
                    _createElementVNode("button", {
                      class: "btn btn-medium btn-icon btn-play btn-secondary",
                      onClick: (e) => _ctx.playLineAt(e, i),
                      disabled: !_ctx.isTimelineReady
                    }, _hoisted_27, 8, _hoisted_25),
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createTextVNode(" " + _toDisplayString(Math.trunc(lyric.start)) + " - " + _toDisplayString(Math.trunc(lyric.end)) + " ", 1),
                      _createElementVNode("small", null, "(" + _toDisplayString(Math.trunc(lyric.end - lyric.start)) + " ms)", 1)
                    ]),
                    _createElementVNode("div", {
                      class: "display-table",
                      onPaste: (e)=> _ctx.handlePaste(e, i)
                    }, [
                      _createElementVNode("div", null, [
                        (lyric.delay)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(lyric.delay, (delay, j) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: j,
                                class: "furigana",
                                contenteditable: "false"
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "onUpdate:modelValue": ($event: any) => ((lyric.delay[j]) = $event),
                                  min: "0",
                                  max: lyric.end - lyric.start,
                                  style: {"font-size":"12px"},
                                  onInput: (e) => _ctx.onValueDragged(e.target.value, lyric, j, delay)
                                }, null, 40, _hoisted_31), [
                                  [_vModelText, lyric.delay[j]]
                                ])
                              ]))
                            }), 128))
                          : _createCommentVNode("", true),
                        _createElementVNode("small", {
                          contenteditable: "false",
                          class: _normalizeClass(["small-total", {'verse_not_synched': !_ctx.isVersedSynched(lyric), verse_synched: _ctx.isVersedSynched(lyric)}])
                        }, "=" + _toDisplayString(Math.trunc(lyric.totalMs)) + " ms", 3)
                      ]),
                      _createElementVNode("div", null, [
                        (lyric.furigana)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(lyric.furigana, (furigana, j) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: furigana,
                                id: 'fg-' + j,
                                class: "furigana"
                              }, [
                                _createElementVNode("input", {
                                  type: "text",
                                  value: furigana,
                                  class: "w-auto focus:outline-none text-center",
                                  onChange: (e) => _ctx.editingFurigana(e, furigana)
                                }, null, 40, _hoisted_33)
                              ], 8, _hoisted_32))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lyric.characters, (character) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: character,
                            id: 'ch-' + character.id
                          }, _toDisplayString(character.key), 9, _hoisted_35))
                        }), 128))
                      ])
                    ], 40, _hoisted_30),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("input", {
                        type: "text",
                        value: lyric.romaji,
                        placeholder: "Enter here the romaji",
                        class: "w-full focus:outline-none text-center"
                      }, null, 8, _hoisted_37)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("input", {
                        type: "text",
                        value: lyric.en,
                        placeholder: "Enter here the english translation",
                        class: "w-full focus:outline-none text-center"
                      }, null, 8, _hoisted_39),
                      _hoisted_40
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("input", {
                        type: "text",
                        value: lyric.es,
                        placeholder: "Enter here the spanish translation",
                        class: "w-full focus:outline-none text-center"
                      }, null, 8, _hoisted_42)
                    ])
                  ], 8, _hoisted_24))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("button", {
          class: "btn btn-icon btn-mode btn-medium btn-secondary",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendForRevision && _ctx.sendForRevision(...args))),
          title: _ctx.actions_send_revision
        }, _hoisted_46, 8, _hoisted_44),
        _createElementVNode("button", {
          class: "btn btn-icon btn-mode btn-medium btn-secondary",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
          title: _ctx.actions_save
        }, _hoisted_49, 8, _hoisted_47),
        _createElementVNode("button", {
          class: "btn btn-icon btn-close btn-medium btn-secondary",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
          title: _ctx.actions_goback
        }, _hoisted_52, 8, _hoisted_50)
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("button", {
          class: "btn btn-icon btn-previous btn-secondary",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.playPreviousLine && _ctx.playPreviousLine(...args))),
          disabled: !_ctx.isPlaying,
          title: _ctx.actions_go_next_verse
        }, _hoisted_56, 8, _hoisted_54),
        _createElementVNode("button", {
          class: "btn btn-icon btn-next btn-secondary",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.playNextLine && _ctx.playNextLine(...args))),
          disabled: !_ctx.isPlaying,
          title: _ctx.actions_go_prev_verse
        }, _hoisted_59, 8, _hoisted_57)
      ])
    ]),
    _createVNode(_component_Timeline, {
      defaultPoses: _ctx.timelineVerses,
      onSelected: _cache[7] || (_cache[7] = e => _ctx.onTimelineVerseClick(e)),
      onOnFrameMoving: _ctx.onFrameMoving,
      onTimelineUpdate: _ctx.timelineUpdate
    }, null, 8, ["defaultPoses", "onOnFrameMoving", "onTimelineUpdate"])
  ], 64))
}